import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBTextAreaObjective, DBCheckBoxObjective } from '_components';
import styles from './Common.module.css'

class ObservationGeneralRow extends React.Component {

    handleClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, this.props.textareaColumnName);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.checkbox_row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field={this.props.checkboxColumnName}
                        label={this.props.label}
                        className={styles.textarea}
                        onClick={(selected) => this.handleClick(selected)}
                    />
                </div>
                { this.props.checked &&
                    <div className={styles.textarea_row}>
                        <span className={styles.flag} />
                        <span className={styles.label} />
                        <DBTextAreaObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field={this.props.textareaColumnName}
                            className={styles.textarea}
                        />
                    </div >
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        checked: state.entities.notes.PTOBJECTIVEOBS[oono][ownprops.checkboxColumnName] ? true : false
    };
}

const connectedObservationGeneralRow = connect(mapStateToProps, mapDispatchToProps)(ObservationGeneralRow);
export { connectedObservationGeneralRow as ObservationGeneralRow };


